var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9971 0.986328L8.80066 1.64267V20.6882L8.9971 20.881L17.9906 15.6553L8.9971 0.986328Z",
    fill: "#7160EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99353 0.986328L0 15.6553L8.99353 20.8811V11.6369V0.986328Z",
    fill: "#A096ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00095 22.5512L8.89026 22.6839V29.4683L9.00095 29.7862L17.9998 17.3281L9.00095 22.5512Z",
    fill: "#7160EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99353 29.7862V22.5512L0 17.3281L8.99353 29.7862Z",
    fill: "#A096ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00171 20.8827L17.9951 15.657L9.00171 11.6387V20.8827Z",
    fill: "#3C2BB9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.657L8.99338 20.8827V11.6387L0 15.657Z",
    fill: "#7160EE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth.f70f229e64c661088f388fe5f927d759.svg";